import DynamicColorClickableRowHtml from '../../app-lite/grids/templates/row.dynamic-color.clickable.html';
import GridFooterHtml               from '../../app-lite/grids/templates/footer.html';

export function CommunicationCenterCtrl (
  $state,
  $scope,
  $translate,
  $window,
  API,
  blockUI,
  communicationTypes,
  contactTypes,
  customerSources,
  gridAPI,
  messages,
  recaptchaApi,
  sessionObjAPI,
  templatedWording,
  workshopAPI
) {

  $scope.communicationTypes = communicationTypes;
  $scope.contacts           = [];
  $scope.contactsBlock      = blockUI.instances.get('contactsBlock');
  $scope.contactTypes       = contactTypes;
  $scope.customerSources    = customerSources;
  $scope.regoLabel          = sessionObjAPI.company().company_variable_fields.plate_number_name || sessionObjAPI.countrySettings().rego_label;
  $scope.selectedCustomers  = [];

  $scope.comm_messages = {
    document_message: '',
    email_message   : '',
    email_subject   : '',
    sms_message     : ''
  };

  $scope.filters = {
    communication_type: 'customer',
    contact_type      : '*'
  };

  $scope.paging = {
    currentPage: 1,
    pageSize   : 10,
    pageSizes  : [ 10, 25, 50 ],
    count () {
      return workshopAPI.get('/communication_centre/search_count', [
        $scope.filters.contact_type,
        $scope.filters.communication_type,
        $scope.filters.from_postcode || '*',
        $scope.filters.to_postcode || '*',
        $scope.filters.make || '*',
        $scope.filters.model || '*',
        $scope.filters.build_year || '*',
        $scope.filters.customer_source || '*',
        $scope.filters.last_in_start || '*',
        $scope.filters.last_in_end || '*',
      ]);
    },
    lastPage () {
      return gridAPI.lastPage(this);
    }
  };

  $scope.sorting = {
    directions: ['asc'],
    fields    : ['display_name']
  };

  $scope.grid = {
    columnDefs             : 'colDefs',
    data                   : 'contacts',
    enableRowSelection     : true,
    filterOptions          : $scope.filtering,
    footerTemplate         : GridFooterHtml,
    multiSelect            : false,
    pagingOptions          : $scope.paging,
    rowHeight              : 43,
    rowTemplate            : DynamicColorClickableRowHtml,
    showFooter             : true,
    sortInfo               : $scope.sorting,
    storageKey             : 'communicationGrid',
    useExternalSorting     : true,
    virtualizationThreshold: Math.max.apply(null, $scope.paging.pageSizes)
  };

  $scope.addTemplates = function ( type ) {
    templatedWording.addTemplate(type)
    .then(templates => {
      angular.forEach(templates, template => {
        const wording = String(template.wording).replace(/<[^>]+>/gm, '');

        if (type === 'sms') {
          $scope.comm_messages.sms_message = $scope.comm_messages.sms_message
            ? `${ $scope.comm_messages.sms_message }\n\n${ wording }`
            : wording;
        }
        else if (type === 'email') {
          $scope.comm_messages.email_message = $scope.comm_messages.email_message
            ? `${ $scope.comm_messages.email_message }\n\n${ wording }`
            : wording;
        }
        else if (type === 'document') {
          $scope.comm_messages.document_message = $scope.comm_messages.document_message
            ? `${ $scope.comm_messages.document_message }\n\n${ wording }`
            : wording;
        }

      });
    });
  };

  $scope.changeCommunicationType = function () {
    $scope.contacts          = [];
    $scope.selectedCustomers = [];

    $scope.getColDefs();
  };

  $scope.getColDefs = function () {
    $scope.colDefs = (
      $scope.filters.communication_type === 'postcode'
      || $scope.filters.communication_type === 'customer'
      || $scope.filters.communication_type === 'source'
    ) ? [
      {
        displayName   : $translate.instant('CUSTOMER_SPACE.CUSTOMER'),
        enableCellEdit: false,
        field         : 'display_name'
      },
      {
        displayName   : $translate.instant('GENERAL_SPACE.FIELD.EMAIL'),
        enableCellEdit: false,
        field         : 'email'
      },
      {
        displayName   : $translate.instant('GENERAL_SPACE.FIELD.MOBILE'),
        enableCellEdit: false,
        field         : 'mobile'
      },
      {
        displayName   : $translate.instant('GENERAL_SPACE.FIELD.SEND_TYPE'),
        enableCellEdit: false,
        field         : 'contact_type'
      }
    ] : [
      {
        displayName   : $translate.instant('CUSTOMER_SPACE.CUSTOMER'),
        enableCellEdit: false,
        field         : 'display_name'
      },
      {
        displayName   : $translate.instant('GENERAL_SPACE.FIELD.EMAIL'),
        enableCellEdit: false,
        field         : 'email'
      },
      {
        displayName   : $translate.instant('GENERAL_SPACE.FIELD.MOBILE'),
        enableCellEdit: false,
        field         : 'mobile'
      },
      {
        displayName   : $translate.instant('GENERAL_SPACE.FIELD.TYPE'),
        enableCellEdit: false,
        field         : 'contact_type'
      },
      {
        displayName   : $scope.regoLabel,
        enableCellEdit: false,
        field         : 'plate_number'
      },
      {
        displayName   : $translate.instant('VEHICLE_SPACE.MAKE'),
        enableCellEdit: false,
        field         : 'make'
      },
      {
        displayName   : $translate.instant('VEHICLE_SPACE.MODEL'),
        enableCellEdit: false,
        field         : 'model'
      },
      {
        displayName   : $translate.instant('VEHICLE_SPACE.YEAR'),
        enableCellEdit: false,
        field         : 'build_date'
      }
    ];
  };

  $scope.getRowColor = function ( item, column ) {
    const classes = gridAPI.getColumnClasses(column);

    if (($scope.filters.communication_type === 'vehicle') || ($scope.filters.communication_type === 'last_in')) {
      if ($scope.selectedCustomers.filter(customer => customer.vehicle_id === item.vehicle_id).length) {
        classes.push('bg-selected');
      }
    } else {
      if ($scope.selectedCustomers.filter(customer => customer.customer_id === item.customer_id).length) {
        classes.push('bg-selected');
      }
    };

    return classes;
  };

  $scope.isCommunicationType = function ( type ) {
    return $scope.filters.communication_type === type;
  };

  $scope.isContactType = function ( type ) {
    return $scope.filters.contact_type === type;
  };

  $scope.onRowClick = function ( row ) {
    let index = -1;

    if ( ($scope.filters.communication_type === 'vehicle') || ($scope.filters.communication_type === 'last_in') ) {
      for ( let i = 0; i < $scope.selectedCustomers.length; i++ ) {

        if ($scope.selectedCustomers[i].vehicle_id === row.vehicle_id) {
          index = i;
          i = $scope.selectedCustomers.length;
        }
      }
      index >= 0 ?
        $scope.selectedCustomers.splice(index, 1): $scope.selectedCustomers.push({ customer_id: row.customer_id, preferred_contact_method: row.contact_type, vehicle_id: row.vehicle_id });
    }
    else {
      for ( let i = 0; i < $scope.selectedCustomers.length; i++ ) {
        if ($scope.selectedCustomers[i].customer_id === row.customer_id) {
          index = i;
          i = $scope.selectedCustomers.length;
        }
      }
      index >= 0 ?
        $scope.selectedCustomers.splice(index, 1):
        $scope.selectedCustomers.push({ customer_id: row.customer_id, preferred_contact_method: row.contact_type });
    }
  };

  $scope.search = function ( resetCurrentPage = true ) {
    if ( resetCurrentPage ) {
      $scope.grid = gridAPI.resetCurrentPage($scope.grid);
    }

    return gridAPI.getPage('/communication_centre/communication_filter_search', [
      $scope.filters.contact_type,
      $scope.filters.communication_type,
      $scope.filters.from_postcode || '*',
      $scope.filters.to_postcode || '*',
      $scope.filters.make || '*',
      $scope.filters.model || '*',
      $scope.filters.build_year || '*',
      $scope.filters.customer_source || '*',
      $scope.filters.last_in_start || '*',
      $scope.filters.last_in_end || '*',
      gridAPI.getOffset($scope.paging),
      gridAPI.getPageSize($scope.paging),
      $scope.sorting.fields[0],
      $scope.sorting.directions[0]
    ], $scope.grid)
    .then(contacts => {
      $scope.contacts = contacts;

      return contacts;
    });
  };

  $scope.selectAll = function () {
    $scope.contactsBlock.start();

    $scope.paging.count()
    .then(data => {
      return workshopAPI.get('/communication_centre/communication_filter_search', [
        $scope.filters.contact_type,
        $scope.filters.communication_type,
        $scope.filters.from_postcode || '*',
        $scope.filters.to_postcode || '*',
        $scope.filters.make || '*',
        $scope.filters.model || '*',
        $scope.filters.build_year || '*',
        $scope.filters.customer_source || '*',
        $scope.filters.last_in_start || '*',
        $scope.filters.last_in_end || '*',
        0,
        data,
        $scope.sorting.fields[0],
        $scope.sorting.directions[0]
      ])
      .then(contacts => {
        $scope.selectedCustomers = [];

        angular.forEach(contacts, contact => {
          if (($scope.filters.communication_type === 'vehicle') || ($scope.filters.communication_type === 'last_in')) {
            $scope.selectedCustomers.push({
              customer_id             : contact.customer_id,
              email                   : contact.email,
              mobile                  : contact.mobile,
              preferred_contact_method: contact.contact_type,
              vehicle_id              : contact.vehicle_id
            });
          }
          else {
            $scope.selectedCustomers.push({
              customer_id             : contact.customer_id,
              email                   : contact.email,
              mobile                  : contact.mobile,
              preferred_contact_method: contact.contact_type
            });
          }
        });
      })
      .catch(err => {
        messages.error(err);
      })
      .finally(() => {
        $scope.contactsBlock.stop();
      });
    });
  };

  $scope.selectNone = function () {
    $scope.selectedCustomers = [];
  };

  $scope.sendCommunication = function () {
    recaptchaApi.verifyUser()
    .then(() => {
      return workshopAPI.post('/communication_centre/request_send_communication', {
        comm_messages     : $scope.comm_messages,
        communication_type: $scope.filters.communication_type,
        contact_type      : $scope.filters.contact_type,
        customer_list     : $scope.selectedCustomers
      });
    })
    .then(data => {
      if ($scope.filters.contact_type === 'print' || ( $scope.filters.contact_type === '*' && data.document) ) {
        $window.open(`${API.url}/reports/jasper_service_reminders.pdf`);
      }

      if (data.warning) {
        messages.show(data.message, 'warning');
      }
      else {
        messages.show(data.message, 'success');
      }

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.smsLengthWarning = function () {
    if ($scope.comm_messages.sms_message.length <= 150) {
      return 'text-success';
    }
    else if ($scope.comm_messages.sms_message.length < 160) {
      return 'text-warning';
    }
    else {
      return 'text-danger';
    }
  };

  $scope.$watch('[ paging.pageSize, paging.currentPage, sorting.directions, sorting.fields ]', ( newVal, oldVal ) => {
    if (newVal !== oldVal) {
      $scope.search(false);
      gridAPI.updatePreferences($scope.grid);
    }
  }, true);

  $scope.getColDefs();

  gridAPI.init($scope.contacts, $scope.grid);

}